import http from '../../../base/api/public'
let service = require('@/../config/serviceList');
let sysConfig = require('@/../config/sysConfig');
let apiPre = sysConfig.apiPre;
export default {

  getStatisticData (params) {
    return http.requestPost(apiPre + service.ops + '/ops/statistic/alarmStatistic', params)
  }

}



// WEBPACK FOOTER //
// ./src/module/dataCenter/api/alarmRecordStatistic.js